const FEATURES = [
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '50000+部影片覆盖全球热门电影、经典老片和独立佳作，类型齐全，从动作科幻到文艺纪录应有尽有。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '所有影片默认提供高清分辨率，部分热门大片支持1080P超清画质，给你影院级的视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '全球CDN加速节点保障，智能码率自适应技术，确保不同网络环境下都能流畅播放不卡顿。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '专业编辑团队每日精选最新影片入库，院线下线大片、热门网大第一时间上架，永不错过好片。',
  },
  {
    icon: 'ri-vip-diamond-line',
    title: '完全免费',
    desc: '零门槛观影体验，无需注册、无需VIP、无需付费，打开网站即可畅享高清电影大全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择6080影视
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大核心优势，为你打造极致免费观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="flex flex-col items-center text-center p-5 rounded-lg bg-background-100 border border-background-200/60"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-700 mb-3">
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}